<div class="container">
  <div class="header" *ngIf="stickyHeader">
    <ng-container
      *ngIf="dataSource.getHeaderForIndexPath(currentSectionIndex) | async as header"
    >
      <ng-container *ngTemplateOutlet="headerTemplate; context: { $implicit: header, isSticky: true }"></ng-container>
    </ng-container>
  </div>

  <ts-virtual-scroll
    *ngIf="numberOfRows - paddingNodes > 0; else noDataTemplate"
    class="scroll-content"
    [(locationRow)]="locationRow"
    [paddingNodes]="paddingNodes"
    [rowTemplate]="scrollRow"
    [rowHeight]="rowHeight"
    [itemCount]="numberOfRows"
    [gap]="rowGap"
    [scrollThreshold]="scrollThreshold"
    [delegate]="scrollDelegate"
    [dragSelectionEnabled]="dragSelectionEnabled"
    [dragSelectionHitTester]="dragSelectionHitTester"
    [dragSelectionDelegate]="dragSelectionDelegate"
    (startIndexChanged)="updateCurrentRow($event)"
  >
    <ng-template #scrollRow let-row>
      <ng-container *ngIf="isSectionRow(row); else dataRow">
        <div class="fixed" *ngIf="dataSource.getHeaderForIndexPath(getSectionIndexForRow(row)) | async as header">
          <ng-container *ngTemplateOutlet="headerTemplate; context: { $implicit: header }"></ng-container>
        </div>
      </ng-container>

      <ng-template #dataRow>
        <ng-container *ngIf="getIndexPathForRow(row) as indexPath">
          <div class="flexed" [style.gap]="rowGap + 'px'" [style.height]="rowHeight">
            <div class="fixed" *ngIf="dataSource.getRowNumberForIndexPath(indexPath) | async as rowNumber">
              <ng-container *ngTemplateOutlet="rowNumeralTemplate; context: { $implicit: rowNumber }"></ng-container>
            </div>
            <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: indexPath }"></ng-container>
          </div>
        </ng-container>
      </ng-template>
    </ng-template>
  </ts-virtual-scroll>

  <ng-template #noDataTemplate>
    <div class="scroll-content">
      <ng-content select="[slot='no-items']"></ng-content>
    </div>
  </ng-template>

  <div *ngIf="loading" class="loader">
    <ng-content select="[slot='loader']"></ng-content>
  </div>
</div>
